import { useContext } from 'react';

import { UserPermissionContext } from '../contexts/PermissionContext';

export const usePermissions = () => {
  return useContext(UserPermissionContext);
};
